import { cloneDeep } from "es-toolkit";
import { ref } from "vue";
/**
 * @description 제품 선택 관련 함수, 테이블 데이터 선택 시 사용
 * @property {Ref<T[]>} selectedItems 선택된 아이템 리스트
 * @property {Function} isAdded 선택된 아이템 존재 여부 확인
 * @property {Function} addItem 선택된 아이템 추가 함수
 * @property {Function} deleteItem 선택된 아이템 삭제
 * @property {Function} clearItems 선택된 아이템 전체 삭제
 * @property {Function} applyItems 선택된 아이템 전체 적용
 */
export const useSelectProduct = () => {
    const selectedItems = ref([]);
    const isAdded = (item, uniqueValue) => {
        return selectedItems.value.some((el) => el[uniqueValue] === item[uniqueValue]);
    };
    const addItem = (item) => {
        selectedItems.value.push(cloneDeep(item));
    };
    const deleteItem = (item, uniqueValue) => {
        selectedItems.value = selectedItems.value.filter((el) => el[uniqueValue] !== item[uniqueValue]);
    };
    const clearItems = () => {
        selectedItems.value = [];
    };
    const applyItems = (items) => {
        selectedItems.value = items;
    };
    return {
        selectedItems,
        isAdded,
        addItem,
        deleteItem,
        clearItems,
        applyItems,
    };
};
